import makeStyles from "@material-ui/core/styles/makeStyles";
import { createStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    inputField: {
      minWidth: "11vw",
      marginLeft: "5px"
    },
    errorMsg: {
      width: "150px",
      marginLeft: "5px"
    }
  })
);
